module.exports = __webpack_public_path__ + "img/win-s2-9.7d8af98f.png";